const destinationData = {
	id: '202203-kilz', // this id will be given to the div that wraps your destination markup.
	lander: {
		hed: "A Year in DIYs",
		subHed: "Your Home Improvement Calendar <i>for</i> Paint Projects by Season",
		intro: "We’ve been fairly housebound going on about two years now (mind = blown). So if you’ve found yourself daydreaming about new projects to improve and refresh your home again, you’re certainly not alone. You’ve also come to the right place. Here, our top three projects per season, at every level of difficulty. Think you’re up for the challenge? Download our <a href='https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/KilzChecklist.pdf' target='_blank'>printable checklist</a> and pin it to your mood board to keep your goals in sight—and in reach.",
		metaDescription: "This no-stress guide to common holiday triggers will add some sparkle back into the season.",
		titleTag: "Your No-Stress Guide to the Holidays - PureWow",
		author: "Roberta Fiorito",
		bgImage: {
			desktop: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/lander_desktop.jpg",
			mobile: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/lander_mobile.jpg", 
		},
		textImage: {
			desktop: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_desktop.png",
			mobile: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_mobile.png",
		},
	},
	sections: [{
		// Section 1
		season: "winter",
		hed: "Creating a Haven",
		navImage: {
			desktop: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/desktop_nav_winter.jpg",
			mobile: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/mobile_nav_winter.png",
		},
		subSections: [{
			level: "Easy",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_easy.png",
			title: "A Bold Exit",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_easy.jpg",
			credit: "Kilz",
			body: "Forget making an entrance. Paint the inside of your front door a moody black (how very 2022 of you) for an impressive exit factor instead. To nail this statement look, prep and prime the inside of your door with <a href='https://www.kilz.com/primer/kilz-2' target='_blank'>KILZ 2</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-2' target='_blank'> All-Purpose Primer</a>: a fast drying, multi-surface stain blocker that seals surfaces, has high hiding and cleans up with soap and water.",
			products: [{
				name: "KILZ 2<sup>Ⓡ</sup> All-Purpose Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_easy_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-2",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Fine Black",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_easy_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/fine-black-JG-144",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}, {
			level: "Medium",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_medium.png",
			title: "Bedroom Cleanup",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_medium.jpg",
			credit: "Kilz",
			body: "The bedroom is often the last room of the house to get tackled. But we say, make this the year of putting yourself first. While abstract designs and statement colors have their place, in the primary bedroom, we’re craving the clean lines and orderly, reassuring arrangements only a crisp white backdrop can provide. Clean and prime your walls with <a href='https://www.kilz.com/primer/kilz-2' target='_blank'>KILZ 2</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-2' target='_blank'> All-Purpose Primer</a> before going at them with fresh color, and please, don’t forget the built-ins and trim.",
			products: [{
				name: "KILZ 2<sup>Ⓡ</sup> All-Purpose Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_medium_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-2",
				gaLabel: "",
			}, {
				name: "KILZ<sup>Ⓡ</sup> Tribute in Ultra Bright White",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_medium_product_2.jpg",
				link: "https://www.kilz.com/color/ultra-bright-white-TB-01",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}, {
			level: "Hard",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_hard.png",
			title: "Vanity Thrift Flip",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_hard_before.jpg",
			imgCompare: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_hard_after.jpg",
			credit: "mckenzie cordell",
			body: "If you always see gorgeous curio cabinets and dressers at the flea market—but don’t necessarily need another storage piece—then we’ve got the perfect project for you. Start by sanding it down, then prime it with <a href='https://www.kilz.com/primer/kilz-mold--mildew' target='_blank'>KILZ</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-mold--mildew' target='_blank'> Mold & Mildew Primer</a>. (Psst, this primer is great for bathrooms because it contains an EPA-registered mildewcide, which helps prevent mold and mildew growth on the primed surface.)  Paint it a light shade (bright and airy bathrooms are always on-trend) and install a sink for a romantic cottagecore-meets-modern take on a vanity. At-home haven = achieved.",
			products: [{
				name: "KILZ<sup>Ⓡ</sup> Mold & Mildew Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_hard_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-mold--mildew",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Silos White",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_hard_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/silos-white-JG-107 ",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}]
	}, {
		// Seciton 2
		season: "spring",
		hed: "Get It Done",
		subSections: [{
			level: "Easy",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_easy.png",
			title: "Functional Workspace",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_easy.jpg",
			credit: "Kilz",
			body: "Even if you don’t have a dedicated office, you can still have a beautiful and functional space when you’re working from home. Turn an open wall into your own personal study and give it a pop of color to make it come alive. Start with <a href='https://www.kilz.com/primer/kilz-2' target='_blank'>KILZ 2</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-2' target='_blank'> All-Purpose Primer</a> to hide any unsightly scuffs or marks and provide excellent adhesion for your new topcoat.",
			products: [{
				name: "KILZ 2<sup>Ⓡ</sup> All-Purpose Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_easy_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-2",
				gaLabel: "",
			}, {
				name: "KILZ<sup>Ⓡ</sup> Tribute in American Pine",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_easy_product_2.jpg",
				link: "https://www.kilz.com/color/american-pine-TB-69#",
				gaLabel: "",
			}]
		}, {
			level: "Medium",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_medium.png",
			title: "The Statement Ceiling",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_medium_before.jpg",
			imgCompare: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_medium_after.jpg",
			credit: "mckenzie cordell",
			body: "Hey, those ceilings need love too. Cover any discoloration from things like stains and candle soot with a fresh, even coat of white. You’ll make your room feel more open and airy, all while checking off a major to-do from your list. <a href='https://www.kilz.com/paint/kilz-color-change-ceiling' target='_blank'>KILZ</a> <sup>Ⓡ</sup><a href='https://www.kilz.com/paint/kilz-color-change-ceiling' target='_blank'> Stainblocking Ceiling Paint</a> is exactly what you need to block out common ceiling stains (with minimal splatter while you work).",
			products: [{
				name: "KILZ<sup>Ⓡ</sup> Stainblocking Ceiling Paint",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_medium_product_1.png",
				link: "https://www.kilz.com/paint/kilz-color-change-ceiling",
				gaLabel: "",
			}]
		}, {
			level: "Hard",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_hard.png",
			title: "If Shelves Could Talk",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_hard.jpg",
			credit: "Kilz",
			body: "Finally give that book collection the attention it deserves with a statement backdrop that speaks volumes. In fact, consider it a hop on the “emotional escape room” bandwagon. Yep, folks are using everything from calming colors to crystals to create rooms in their homes that elicit their most tranquil selves. So don’t shy away from a shade that brings you joy, no matter how strong—simply prime with <a href='https://www.kilz.com/primer/kilz-restoration' target='_blank'>KILZ Restoration</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-restoration' target='_blank'> Interior Primer</a>, which blocks heavy stains and odors to restore even the toughest projects.",
			products: [{
				name: "KILZ Restoration<sup>Ⓡ</sup> Interior Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_hard_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-restoration",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Under the Stars",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/spring/spring_hard_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/under-the-stars-JG-82 ",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}]
	}, {
		//Section 3
		season: "summer",
		hed: "Together",
		subSections: [{
			level: "Easy",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_easy.png",
			title: "Spa-Like Retreat",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_easy.jpg",
			credit: "kilz",
			body: "If you crave a little extra rest and relaxation after a long day, why not refresh your bathroom walls to evoke a spa-like retreat? Use <a href='https://www.kilz.com/primer/kilz-mold--mildew' target='_blank'>KILZ</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-mold--mildew' target='_blank'> Mold & Mildew Primer</a>, which is specially designed for surfaces in high humidity, moisture and temperature environments. The EPA registered active ingredient creates a mold and mildew resistant film that protects the primer film from mold and mildew growth. Finish with a topcoat in a serene color and voila, your very own spa-like bathroom.",
			products: [{
				name: "KILZ<sup>Ⓡ</sup> Mold & Mildew Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/winter/winter_hard_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-mold--mildew",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Shiplap",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_easy_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/shiplap-JG-22",
				gaLabel: "",
			}]
		}, {
			level: "Medium",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_medium.png",
			title: "Nursery Detail",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_medium.jpg",
			credit: "Kilz",
			body: "You know what would kick your baby’s room up a notch? A statement wall. But before you whip out the bright yellow, consider catching the eye with textural detail instead. Install vertical trim for a striped beadboard effect that adds an element of fun that’s still soft enough for good sleep. Look to <a href='https://www.kilz.com/primer/kilz-premium' target='_blank'>KILZ 3</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-premium' target='_blank'> Premium Primer</a> for your priming step before painting your finished product a warm white. The thicker formula has a strong stain-blocking power that hides kids’ stains (like food and markers) and a very low VOC.",
			products: [{
				name: "KILZ 3<sup>Ⓡ</sup> Premium Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_medium_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-premium",
				gaLabel: "",
			}, {
				name: "KILZ<sup>Ⓡ</sup> Tribute in Contemporary White",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_medium_product_2.jpg",
				link: "https://www.kilz.com/color/contemporary-white-TB-02",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}, {
			level: "Hard",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_hard.png",
			title: "Flavorful Cabinets",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_hard.jpg",
			credit: "Kilz",
			body: "Give the heart of the home an inviting refresh with one of our favorite kitchen trends: two-tone cabinets. After priming with <a href='https://www.kilz.com/primer/kilz-premium' target='_blank'>KILZ 3</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-premium' target='_blank'> Premium Primer</a>, brush a darker color on the lower cabinets to draw the eye upward, creating taller-looking ceilings and a grander visual effect. It’s also a great way to infuse character into the room, and if you’re torn between a rich color palette or soft neutrals, you can have both.",
			products: [{
				name: "KILZ 3<sup>Ⓡ</sup> Premium Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_hard_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-premium",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Together",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/summer/summer_hard_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/together-JG-87",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}]
	}, {
		// Section 4
		season: "fall",
		hed: "On the Horizon",
		subSections: [{
			level: "Easy",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_easy.png",
			title: "Dining Room Accent Wall",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_easy.jpg",
			credit: "Kilz",
			body: "After years of minimalism, maximalist interiors are taking over in a big way, and the impact they’re having on color is bold. Add exciting glamor to a once simple dining room by priming a single wall with <a href='https://www.kilz.com/primer/kilz-premium' target='_blank'>KILZ 3</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-premium' target='_blank'> Premium Primer</a>, then paint it a striking color. Watch how it transforms your light fixtures and dining table right before your eyes.",
			products: [{
				name: "KILZ 3<sup>Ⓡ</sup> Premium Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_easy_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-premium",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Under the Stars",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_easy_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/under-the-stars-JG-82",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}, {
			level: "Medium",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_medium.png",
			title: "Kids’ Play Nook",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_medium_before.jpg",
			imgCompare: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_medium_after.jpg",
			credit: "mckenzie cordell",
			body: "Turn a little-used coat closet or the space under the stairs into a hangout for kids. After priming with <a href='https://www.kilz.com/primer/kilz-2' target='_blank'>KILZ 2</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-2' target='_blank'> All-Purpose Primer</a>, paint it a bright, engaging color, add floor pillows and string lights, and you have a space fit for reading, games and little imaginations.",
			products: [{
				name: "KILZ 2<sup>Ⓡ</sup> All-Purpose Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_medium_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-2",
				gaLabel: "",
			}, {
				name: "KILZ<sup>Ⓡ</sup> Tribute in Canary Song",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_medium_product_2.jpg",
				link: "https://www.kilz.com/color/canary-song-TB-86",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}, {
			level: "Hard",
			levelImg: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/lander/torn_paper_hard.png",
			title: "Family Room Built-Ins",
			img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_hard.jpg",
			credit: "Kilz",
			body: "Finally, set your family up for their most organized year yet with built-ins. But by no means do you need to compromise form for function when you paint your new units a rich, moody black (hey, bold color is in, remember?). Prime with <a href='https://www.kilz.com/primer/kilz-premium' target='_blank'>KILZ 3</a><sup>Ⓡ</sup><a href='https://www.kilz.com/primer/kilz-premium' target='_blank'> Premium Primer</a> for a thick, creamy high hide finish, and no judgment if you enlist the pros to tackle this one.",
			products: [{
				name: "KILZ 3<sup>Ⓡ</sup> Premium Primer",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_hard_product_1.jpg",
				link: "https://www.kilz.com/primer/kilz-premium",
				gaLabel: "",
			}, {
				name: "Magnolia Home by Joanna Gaines<sup>Ⓡ</sup> Paint in Fine Black",
				img: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kilz/fall/fall_hard_product_2.jpg",
				link: "https://www.kilz.com/magnolia/color/fine-black-JG-144 ",
				gaLabel: "outboundLink_02_subsection_spruce_things_up_bedding_image",
			}]
		}]
	}]
};

export default destinationData;